import React, { useContext, useState } from "react";
import {
  Drawer,
  IconButton,
  Button,
  Typography,
  Divider,
} from "@mui/material";
import { CheckCircle, Close as CloseIcon } from "@mui/icons-material";
import "../../assets/styles/TrackOrder.scss";
import { GaintOFDOrdersContext } from "../../context";

const TrackOrder = () => {
  const [open, setOpen] = useState(false);
  const { openTracking, setOpenTracking, trackingInfo } = useContext(GaintOFDOrdersContext);
  //   const trackingInfo = [
  //         {
  //             "id": 3759934,
  //             "user_id": 520,
  //             "assign_user_id": null,
  //             "user_emp_code": null,
  //             "order_id": 300843,
  //             "tracking_event_id": null,
  //             "courier_id": null,
  //             "order_no": "25-26/02/PD/776",
  //             "awb_no": "GL110003396",
  //             "lrnum": null,
  //             "customer_mobile": "9899240015",
  //             "merchant_id": 115,
  //             "charged_weight": null,
  //             "status_code": "1",
  //             "status_msg": "Soft Data Uploaded",
  //             "event_date": null,
  //             "event_date_time": null,
  //             "location": null,
  //             "scan_city": null,
  //             "scan_state": null,
  //             "scan_pincode": null,
  //             "scan_lat": null,
  //             "scan_long": null,
  //             "scan_remarks": null,
  //             "created_at": "2025-08-14T19:28:22.000Z",
  //             "updated_at": "2025-08-14T19:28:22.000Z",
  //             "merchantId": 115,
  //             "userId": 520,
  //             "courierId": null,
  //             "trackingEventId": null
  //         },
  //         {
  //             "id": 3760125,
  //             "user_id": 520,
  //             "assign_user_id": "Mazibur Rahman (8429278225)",
  //             "user_emp_code": null,
  //             "order_id": 300843,
  //             "tracking_event_id": 28,
  //             "courier_id": null,
  //             "order_no": "25-26/02/PD/776",
  //             "awb_no": "GL110003396",
  //             "lrnum": "",
  //             "customer_mobile": "9899240015",
  //             "merchant_id": 115,
  //             "charged_weight": null,
  //             "status_code": "25",
  //             "status_msg": "Received at Noida Branch",
  //             "event_date": null,
  //             "event_date_time": null,
  //             "location": "",
  //             "scan_city": "",
  //             "scan_state": "",
  //             "scan_pincode": "",
  //             "scan_lat": "28.557",
  //             "scan_long": "77.3262",
  //             "scan_remarks": "undefined",
  //             "created_at": "2025-08-14T20:06:21.000Z",
  //             "updated_at": "2025-08-14T20:06:21.000Z",
  //             "merchantId": 115,
  //             "userId": 520,
  //             "courierId": null,
  //             "trackingEventId": 28
  //         },
  //         {
  //             "id": 3765691,
  //             "user_id": 33,
  //             "assign_user_id": "MOHIT KUMAR (9027048072)",
  //             "user_emp_code": null,
  //             "order_id": 300843,
  //             "tracking_event_id": 7,
  //             "courier_id": null,
  //             "order_no": "25-26/02/PD/776",
  //             "awb_no": "GL110003396",
  //             "lrnum": "",
  //             "customer_mobile": "9899240015",
  //             "merchant_id": 115,
  //             "charged_weight": null,
  //             "status_code": "7",
  //             "status_msg": "Out for Delivery",
  //             "event_date": null,
  //             "event_date_time": null,
  //             "location": "",
  //             "scan_city": "",
  //             "scan_state": "",
  //             "scan_pincode": "",
  //             "scan_lat": "28.6381",
  //             "scan_long": "77.1874",
  //             "scan_remarks": "undefined",
  //             "created_at": "2025-08-15T17:01:24.000Z",
  //             "updated_at": "2025-08-15T17:01:24.000Z",
  //             "merchantId": 115,
  //             "userId": 33,
  //             "courierId": null,
  //             "trackingEventId": 7
  //         },
  //         {
  //             "id": 3770652,
  //             "user_id": 18,
  //             "assign_user_id": "MOHIT KUMAR (9027048072)",
  //             "user_emp_code": null,
  //             "order_id": 300843,
  //             "tracking_event_id": 8,
  //             "courier_id": null,
  //             "order_no": "25-26/02/PD/776",
  //             "awb_no": "GL110003396",
  //             "lrnum": "",
  //             "customer_mobile": "9899240015",
  //             "merchant_id": 115,
  //             "charged_weight": null,
  //             "status_code": "8",
  //             "status_msg": "Delivered ",
  //             "event_date": null,
  //             "event_date_time": null,
  //             "location": "",
  //             "scan_city": "",
  //             "scan_state": "",
  //             "scan_pincode": "",
  //             "scan_lat": "28.4821429",
  //             "scan_long": "77.0976578",
  //             "scan_remarks": "Okay ",
  //             "created_at": "2025-08-16T10:04:14.000Z",
  //             "updated_at": "2025-08-16T10:04:14.000Z",
  //             "merchantId": 115,
  //             "userId": 18,
  //             "courierId": null,
  //             "trackingEventId": 8
  //         }
  //     ]

  // Sort by latest first
  const sortedData = (trackingInfo && trackingInfo.length > 0) ? [...trackingInfo].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  ) : [];

  // Group events by date (yyyy-mm-dd)
  const groupedByDate = sortedData && sortedData.length > 0 && sortedData.reduce((acc, item) => {
    const d = new Date(item.created_at);
    const key = d.toISOString().split("T")[0];
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "2-digit",
      month: "2-digit",
    });
  };

  const getDaysDifference = (events = []) => {
    if (!events || events.length === 0) return null;

    // Find earliest created_at
    const minDate = new Date(
      Math.min(...events.map((e) => new Date(e.created_at).getTime()))
    );

    // If delivered, use delivered date as end date; else use today
    const deliveredEvent = events.find((e) => e.status_code === "8"); // delivered
    const maxDate = deliveredEvent
      ? new Date(deliveredEvent.created_at)
      : new Date();

    const diffTime = maxDate - minDate;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // days
  };

  const daysTaken = getDaysDifference(trackingInfo);

  return (
    <>
      {/* Drawer */}
      <Drawer
        anchor="right"
        open={openTracking}
        onClose={() => setOpenTracking(false)}
        className="order-track-drawer"
        classes={{ paper: "track-order-drawer" }}
      >
        {/* Header */}
        <div className="drawer-header">
          <Typography variant="h6" className="drawer-title">
            Track Order
          </Typography>
          <IconButton onClick={() => setOpenTracking(false)} size="small" className="close-btn">
            <CloseIcon />
          </IconButton>
        </div>

        <div className="drawer-content">
          {/* Top order info */}
          <div className="order-info">
            <Typography variant="body2">
              <b>AWB#</b> {trackingInfo && trackingInfo.length > 0 && trackingInfo[0]?.awb_no}
            </Typography>
            <Typography variant="body2">
              Day[s] : <b>{daysTaken !== null ? daysTaken : "NA"}</b>
            </Typography>
          </div>

          <Divider className="divider" />

          {/* Timeline */}
          <div className="timeline">
            {Object.keys(groupedByDate).map((dateKey, idx) => (
              <div key={dateKey}>
                {/* Date Group */}
                <Typography variant="subtitle2" className="date-header">
                  {formatDate(dateKey)}
                </Typography>

                {groupedByDate[dateKey].map((item, index) => {
                  const dateObj = new Date(item.created_at);
                  const time = dateObj.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  });

                  return (
                    <div className="timeline-item" key={item.id}>
                      <div className="timeline-icon">
                        <CheckCircle
                          className={
                            idx === 0 && index === 0 ? "icon-active" : "icon-inactive"
                          }
                        />
                        {(index !== groupedByDate[dateKey].length - 1 ||
                          idx !== Object.keys(groupedByDate).length - 1) && (
                            <div className="line" />
                          )}
                      </div>
                      <div className="timeline-content">
                        <Typography variant="body2" className="time">
                          {time}
                        </Typography>
                        <Typography variant="body1" className="status">
                          {item.status_msg}
                        </Typography>
                        {item.assign_user_id && (
                          <Typography variant="caption" className="remarks">
                            {item.assign_user_id}
                          </Typography>
                        )}
                        {item.scan_remarks && item.scan_remarks !== "undefined" && (
                          <Typography variant="caption" className="remarks">
                            {item.scan_remarks}
                          </Typography>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default TrackOrder;
